import api from "@/lib/api";
import { toast } from "sonner";

export const toggleFavorite = async (b, apply) => {
  const on = !b.favorited;
  apply(on);
  try {
    if (on) await api.put(`/beats/${b.beat_id}/favorite`);
    else await api.delete(`/beats/${b.beat_id}/favorite`);
    toast.success(on ? `"${b.title}" added to favourites` : `Removed from favourites`);
  } catch (e) {
    apply(!on);
    toast.error("Could not update favourites");
  }
};
